import { render, staticRenderFns } from "./polarBar.md?vue&type=template&id=2fbec7ce&"
import script from "./polarBar.md?vue&type=script&lang=js&"
export * from "./polarBar.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fbec7ce')) {
      api.createRecord('2fbec7ce', component.options)
    } else {
      api.reload('2fbec7ce', component.options)
    }
    module.hot.accept("./polarBar.md?vue&type=template&id=2fbec7ce&", function () {
      api.rerender('2fbec7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/api/polarBar.md"
export default component.exports